 import { NotifyMessage, useToastNotify } from "contexts/notifyToast";
import React, { useEffect } from "react";

import styles from "./notify.module.scss";


interface NotifyProps {
    data: NotifyMessage;
}

 export const Notify: React.FC<NotifyProps> = ({data}) => {
     const {removeNotify} = useToastNotify();

     useEffect(() => {
        const timer = setTimeout(() => removeNotify(data.id), 5000)

        return () => clearTimeout(timer)
     }, [data.id, removeNotify])


     return (
        <div
        className={[
            styles.notification,
            styles[`notification__${data.template}`],
        ].join(" ")}
    >
        <p>{data.description}</p>

        {data.hasButton && (
            <button
                onClick={data.onClickButton}
                className={styles.notification__button}
                type="button"
            >
                {data.buttonLabel}
            </button>
        )}
    </div>
     )
 }
